import { render } from "./ServiceDetail.vue?vue&type=template&id=3f68e71c&ts=true&lang=pug"
import script from "./ServiceDetail.vue?vue&type=script&lang=ts"
export * from "./ServiceDetail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__